import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

import { isNumber } from "../../../utils"
import { isLTPM } from "../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  set_offset_label: (intl) => (isLTPM ? intl.formatMessage({ id: "graphing.set.offset" }) : "Set Offset"),
}

export default function SetOffsetTrigger(props) {
  const { offset } = props

  let offsetFormatted = offset.toString()
  if (offset > 0) {
    offsetFormatted = "+" + offsetFormatted
  } else if (offset === 0) {
    offsetFormatted = "\u00b1" + offsetFormatted
  }

  return (
    <OverlayTrigger trigger={"click"} placement={"right"} rootClose overlay={<OffsetEditor {...props} />}>
      <a>[{offsetFormatted}]</a>
    </OverlayTrigger>
  )
}

class OffsetEditor extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      offsetFieldValue: props.offset ? props.offset.toString() : "0.0",
    }

    this.onChange = this.onChange.bind(this)
  }

  render() {
    const { setOffsetForRun, offset, intl, run_id, ...otherProps } = this.props

    return (
      // otherProps is used here to style the placement of the popover
      <Popover id="set-run-offset" title={registration.set_offset_label(intl)} {...otherProps}>
        <Popover.Header as={"h3"}>{registration.set_offset_label(intl)}</Popover.Header>
        <Popover.Body>
          <input
            type="text"
            value={this.state.offsetFieldValue}
            onChange={this.onChange}
            ref={(input) => {
              this.input = input
            }}
          />
        </Popover.Body>
      </Popover>
    )
  }

  onChange(ev) {
    this.setState({
      offsetFieldValue: ev.target.value,
    })

    const val = parseFloat(ev.target.value || 0)
    if (isNumber(val) && val !== this.props.offset) {
      this.props.setOffsetForRun(this.props.run_id, val)
    }
  }
}
